import {static_url} from './config';

export const filters = {
    //图片
    img: (value, key='path') => {
        if (Array.isArray(value)) value = value[0][key];
        if (value) {
            if (!value.startsWith('http')) {
                value = `${static_url}${value}`;
            }
        }
        return value ? value : require('@/assets/images/default-banner.png');
    },
};
